import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PassService } from './passEmitData.service';
import { ActivatedRoute } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class BaseService {
  public currentUser: any = {};
  public schoolTypeId: any;
  constructor(
    public http: HttpClient,
    private inj: Injector,
    private pass: PassService,
    private route: ActivatedRoute
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.route.queryParams.subscribe(params => {
      this.schoolTypeId = params['st'];
    });
  }

  checkLoad() {
    this.pass.onLoadOrder(true);
  }

  /** get 1 object T */
  public get<T>(url: string, params?: any): Observable<T> {
    return this.http.get<T>(`${environment.baseUrl}/${url}`, {
      params: this.buildUrlSearchParams(params),
    });
  }

  public getQueue<T>(url: string, params?: any): Observable<T> {
    return this.http.get<T>(`${environment.queueUrl}/${url}`, {
      params,
    });
  }

  /** get 1 list object T */
  public getAll<T>(url: string, params?: any): Observable<T[]> {
    return this.http.get<T[]>(`${environment.baseUrl}/${url}`, {
      params: this.buildUrlSearchParams(params),
    });
  }

  public getWithFilter<T>(url: string, params?: any): Observable<T> {
    return this.http.get<T>(`${environment.baseUrl}/${url}`, {
      params: this.buildUrlSearchParams(params),
    });
  }

  /** get file voi du lieu tra ve kieu Blob */
  public getFile(url: string): Observable<Blob> {
    return this.http.get(`${environment.baseUrl}/${url}`, {
      responseType: 'blob',
    });
  }

  /** get full thong tin voi du lieu tra ve kieu  HttpResponse<T> */
  public getFull<T>(url: string): Observable<HttpResponse<T>> {
    return this.http.get<T>(`${environment.baseUrl}/${url}`, {
      observe: 'response',
    });
  }

  /** post du lieu voi kieu tra ve la 1 object T */
  public post<T>(url: string, data?: any, params?: any): Observable<T> {
    var observer: Observable<T>;
    var subscribe = (observer) => {
      this.http.post<T>(`${environment.baseUrl}/${url}`, data, { observe: "response", params }).subscribe(
        (res) => {
          if (this.currentUser) {
            this.currentUser.token = res.headers.get('Token');
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          }

          observer.next(res.body);
          observer.complete();
        }
      );
    };
    const observable = Observable.create(subscribe);
    return observable;
  }

  public postQueue<T>(url: string, data?: any, params?: any): Observable<T> {
    return this.http.post<T>(`${environment.queueUrl}/${url}`, data, {
      params,
    });
  }

  /** post du lieu voi Files */
  public postWithFile(
    url: string,
    files: File[],
    postData?: any,
    params?: any
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('files', files[0], files[0].name);
    if (postData !== '' && postData !== undefined && postData !== null) {
      for (const property in postData) {
        if (postData.hasOwnProperty(property)) {
          formData.append(property, postData[property]);
        }
      }
    }
    return this.http.post<any>(`${environment.baseUrl}/${url}`, formData, {
      params,
    });
  }
  /** put du lieu voi kieu tra ve la 1 object T */
  public put<T>(url: string, data?: any, params?: any): Observable<T> {
    return this.http.put<T>(`${environment.baseUrl}/${url}`, data, { params });
  }

  /** delete du lieu voi kieu tra ve la 1 object T */
  public delete<T>(url: string, params?: any): Observable<T> {
    return this.http.delete<T>(`${environment.baseUrl}/${url}`);
  }

  private buildUrlSearchParams(params: any): HttpParams {
    let searchParams = new HttpParams();
    if (typeof params === 'object') {
      Object.keys(params).map((p) => {
        searchParams = searchParams.set(p, params[p]);
      });
    }

    return searchParams;
  }
}
